const colors = {
    primary: 'var(--color-primary)',
    primaryOpacity65: 'var(--color-primary-opacity-65)',
    black: '#000000',
    white: '#FFFFFF',
    gray1: 'var(--color-gray1)',
    gray2: 'var(--color-gray2)',
    gray3: 'var(--color-gray3)',
    gray4: 'var(--color-gray4)',
    gray5: 'var(--color-gray5)',
    gray6: 'var(--color-gray6)',
    gray7: 'var(--color-gray7)',
    gray8: 'var(--color-gray8)',
    gray9: 'var(--color-gray9)',
    buttonText: 'var(--color-button-text)',
    buttonDisabled: 'var(--color-button-disabled)',
    icon: 'var(--color-icon)',
    red: 'var(--color-red)',
    green: 'var(--color-green)',
    blue: 'var(--color-blue)',
    textSecondary: 'var(--color-gray7)',
};

export default colors;
